import apiClient from './apiClient.js';

const providerService = {
    getAllProviders(){
       return apiClient.get('/proveedor/'); 
    },
    getProviderById(id){
    return apiClient.get(`/proveedor/${id}/`);
    },
    updateProvider(id, data){
        return apiClient.patch(`/proveedor/${id}/`, data);
    },
    deleteProvider(id){
        return apiClient.delete(`/proveedor/${id}/`);
    },
    createProvider(data){
        return apiClient.post('/proveedor/',data);
    }
}



export default providerService;